export default __webpack_public_path__ + "static/media/wax-wallet-activation-fee-screen.50a41069.png";